<template>
    <div>
        <div class="mb-8">
            <Input
                label="Redemption name" placeholder="Name"
                id="redemption-name" name="name"
                v-model:inputValue="activeRedemption.name"
                :options="{ inputClass: 'h-10' }"
                :errors="tripFormErrors"
            />
        </div>

        <div class="grid grid-cols-2 gap-4 mb-8">
            <div class="col-span-1">
                <Input
                    label="Redemption date" placeholder="Redemption date"
                    id="redemption-date" name="start_date"
                    :options="{ icon: 'calendar', iconPosition: 'left', inputClass: 'h-10' }"
                    :errors="tripFormErrors"
                >
                    <template #input>
                        <FlatPickr
                            :config="dateStartConfig"
                            v-model="activeRedemption.start_date"
                            name="redemption_date" id="redemption-date"
                            :class="[
                                'relative block w-full h-10 rounded border bg-white dark:bg-slate-800 py-1.5 pl-10 text-gray-800 dark:text-gray-100 placeholder:text-slate-500 dark:text-slate-400 focus:z-10 focus:ring-0 placeholder:text-sm',
                                tripFormErrors['start_date']
                                    ? 'border-red-500 hover:border-red-500 focus:border-red-500'
                                    : 'border-slate-200 dark:border-slate-700 focus:border-slate-800 hover:border-slate-800',
                            ]"
                            placeholder="Redemption date"
                            data-hs-id="hs-redemption-other-date"
                        />
                    </template>
                </Input>
            </div>
        </div>

        <div class="mb-8">
            <Input
                label="Location" placeholder="Location"
                id="other-location"
                v-model:inputValue="activeRedemption.other_location"
                :options="{ inputClass: 'h-10' }"
            />
        </div>

        <div class="grid grid-cols-2 gap-4 mb-8">
            <div class="col-span-1">
                <Input id="number-of-travelers" name="number_of_travelers" label="Number of travelers">
                    <template #input>
                        <input
                            type="number" step="1" pattern="[0-9]*"
                            placeholder="Number of travelers"
                            class="w-full h-10 text-sm rounded border border-slate-200 dark:border-slate-700"
                            v-model="activeRedemption.number_of_travelers"
                        />
                    </template>
                </Input>
            </div>
            <div class="col-span-1">
                <div>
                    <label class="block text-slate-600 dark:text-slate-300 text-sm font-medium leading-tight mb-2">
                        Class of service
                    </label>
                    <UiSingleSelect
                        :options="classOptions"
                        v-model="classOfService"
                        labelKey="label" valueKey="value"
                        :label="classOfService?.label ? classOfService.label : 'Class of service'"
                        buttonClass="w-full font-medium whitespace-nowrap rounded shadow border inline-flex items-center gap-x-1.5 bg-white dark:bg-slate-800 px-3 py-2 text-sm text-slate-800 dark:text-slate-100 hover:border-slate-800 focus:!ring-0 focus:!ring-offset-0 focus:!outline-none focus:!border-slate-800 focus-visible:!ring-0 focus-visible:!outline-none disabled:opacity-50 disabled:text-slate-800 dark:text-slate-100 disabled:bg-white dark:bg-slate-800 disabled:border-slate-300 dark:border-slate-600 justify-between font-normal"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useTripsStore } from '@/store/trips';
import FlatPickr from '@/components/ui/SafeFlatPickr.vue';
import Input from '@/components/ui/inputs/ui-input.vue';
import UiSingleSelect from '@/components/ui/inputs/single-select/ui-single-select.vue';

import { computed } from 'vue';

defineProps({
    dateStartConfig: { type: Object, required: true },
});

const { activeRedemption, classOptions, tripFormErrors } = storeToRefs(useTripsStore());

const classOfService = computed({
    get: () => {
        if (typeof activeRedemption.value.class_of_service === 'string') {
            return classOptions.value.find((o) => o.value === activeRedemption.value.class_of_service) || null;
        }
        return activeRedemption.value.class_of_service;
    },
    set: (value) => { activeRedemption.value.class_of_service = value?.value || null; },
});
</script>
